import React from 'react';
import { Clock, User, ArrowRight } from 'lucide-react';

export default function Blogs() {
  const blogs = [
    {
      id: 1,
      title: "A New Era of Trade: Breaking Down the India-EU Free Trade Agreement",
      excerpt: "With the monumental conclusion of the FTA negotiations, we analyze what this means for businesses, tariffs, and cross-border investments in the coming decade.",
      author: "PIEES Economic Research",
      date: "February 2, 2026",
      readTime: "5 min read",
      category: "Trade Policy",
      image: "/images/commercial.jpg"
    },
    {
      id: 2,
      title: "Green Hydrogen & Clean Energy: The EU-India Climate Partnership",
      excerpt: "Exploring the newly formed task forces focused on sustainability, wind business summits, and how the two regions are tackling the green transition together.",
      author: "Sustainability Team",
      date: "January 15, 2026",
      readTime: "4 min read",
      category: "Environment",
      image: "/images/environment.jpg" 
    },
    {
      id: 3,
      title: "Securing the Future: The New Security and Defence Partnership",
      excerpt: "An overview of the first India-EU Security and Defence Dialogue and its implications for maritime security in the Indo-Pacific region.",
      author: "Strategic Affairs",
      date: "December 10, 2025",
      readTime: "6 min read",
      category: "Security",
      image: "/images/strengthen.jpg"
    },
    {
      id: 4,
      title: "Bridging the Digital Divide: Cooperation on 6G and AI",
      excerpt: "Examining the strategic MoUs between the Bharat 6G Alliance and the EU's 6G-IA to build resilient digital infrastructure and govern AI ethically.",
      author: "Tech & Innovation Hub",
      date: "November 22, 2025",
      readTime: "4 min read",
      category: "Technology",
      image: "/images/education.jpg"
    }
  ];

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <div className="bg-slate-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: "url('/images/indo-euro.png')" }}></div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Insights & Perspectives</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Deep dives, policy analysis, and thought leadership on the evolving economic synergy between India and Europe.
          </p>
        </div>
      </div>

      {/* Blogs Grid */}
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <div key={blog.id} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 group flex flex-col">
              <div className="h-56 overflow-hidden relative">
                <img 
                  src={blog.image} 
                  alt={blog.title} 
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" 
                  onError={(e) => { e.target.src = '/images/economic.jpg' }} // Fallback if image doesn't exist
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-blue-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm">
                  {blog.category}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center text-xs text-gray-500 mb-3 space-x-4">
                  <span className="flex items-center"><Clock size={14} className="mr-1" /> {blog.date}</span>
                  <span className="flex items-center"><User size={14} className="mr-1" /> {blog.author}</span>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                  {blog.title}
                </h2>
                <p className="text-gray-600 text-sm mb-6 line-clamp-3 flex-grow">
                  {blog.excerpt}
                </p>
                <div className="pt-4 border-t border-gray-100 mt-auto">
                  <button className="flex items-center text-blue-600 font-medium hover:text-orange-500 transition-colors">
                    Read Article <ArrowRight size={16} className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
